import LabelWithTooltip from './LabelWithTooltip';
import './LabelWithTooltip.scss';

export default LabelWithTooltip;
